const areas = [
  {
    icon: 'ri-store-2-line',
    title: 'Mağaza Cepheleri',
    desc: 'Gece gündüz dikkat çeken mağaza tabelaları ile müşteri trafiğinizi artırın. İç ve dış mekan modelleri ile her cepheye uyum sağlar.',
  },
  {
    icon: 'ri-building-4-line',
    title: 'AVM Mağazaları',
    desc: 'Alışveriş merkezi içindeki mağazanızı çevresinden öne çıkaran ışıklı tabela ve yönlendirme sistemleri.',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Restoran ve Kafeler',
    desc: 'LED menü panoları ile gün boyu güncel ve şık görünen menü ekranları. Baskı değişimi kolay, bakımı pratiktir.',
  },
  {
    icon: 'ri-hospital-line',
    title: 'Eczane ve Klinikler',
    desc: 'IP65 sertifikalı dış mekan modeller ile yağmura ve soğuğa dayanıklı eczane ve sağlık kuruluşu tabelaları.',
  },
  {
    icon: 'ri-hotel-line',
    title: 'Otel ve Lobi Alanları',
    desc: 'Kurumsal kimliğinizi yansıtan otel girişi, lobi yönlendirme ve kat tabelaları; şık tasarım, uzun ömür.',
  },
  {
    icon: 'ri-run-line',
    title: 'Spor Salonları',
    desc: 'Spor tesisi girişi, kat yönlendirme ve iç mekân tabelaları. Enerji tasarruflu LED ile düşük işletme maliyeti.',
  },
  {
    icon: 'ri-building-office-line',
    title: 'Kurumsal Ofisler',
    desc: 'Bina girişi, asansör yönlendirme ve kata ait kurumsal tabelalar. Ofis ve kurumsal kullanım için özel çözümler.',
  },
];

export default function UsageAreas() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-red-600 text-sm font-semibold uppercase tracking-widest mb-4">
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
            Kullanım Alanları
            <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
          </div>
          <h2 className="text-4xl font-black text-gray-900 mb-4">
            Lightbox Nerelerde Kullanılır?
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto leading-relaxed">
            Mağazadan kurumsal binaya, restorandan otele kadar her alanda markanızı gece gündüz öne çıkarın.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {areas.map((area) => (
            <div key={area.title} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-xl mb-4">
                <i className={`${area.icon} text-red-600 text-2xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-2">{area.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{area.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
